module.exports = __webpack_public_path__ + "static/media/hospital.f4e3dac6.svg";